import img1 from "../assets/lab_imges/img1.png";
import img2 from "../assets/lab_imges/img2.png";
import img3 from "../assets/lab_imges/img3.png";
import img4 from "../assets/lab_imges/img4.png";
import img5 from "../assets/lab_imges/img5.png";
import o1 from "../assets/lab_imges/o1.png";
import o2 from "../assets/lab_imges/o2.png";
import o3 from "../assets/lab_imges/o3.png";
import o4 from "../assets/lab_imges/o4.png";
import o5 from "../assets/lab_imges/o5.png";
import o6 from "../assets/lab_imges/o6.png";

export const fakeData = [
  {
    id: 1,
    name: "LeetCode",
    img: img1,
    link: "https://leetcode.com/Abhishekkuntare/",
  },
  {
    id: 2,
    name: "CodeStudio",
    img: img2,
    link: "https://www.codingninjas.com/codestudio/profile/34588505-75de-4268-a22e-dae9685bc9c6",
  },
  {
    id: 3,
    name: "CodeForces",
    img: img3,
    link: "https://codeforces.com/profile/abhishekkuntare7",
  },
  {
    id: 4,
    name: "CodeChef",
    img: img4,
    link: "https://www.codechef.com/users/abhishek_0210",
  },
  {
    id: 5,
    name: "GeeksForGeeks",
    img: img5,
    link: "https://auth.geeksforgeeks.org/user/abhishekkuntare7/practice",
  },
];

export const otherData = [
  {
    id: 1,
    name: "Linkedin",
    img: o3,
    link: "https://www.linkedin.com/in/abhishek-kuntare-65662421b/",
  },
  {
    id: 2,
    name: "Instagram",
    img: o6,
    link: "https://www.instagram.com/abhishekkuntare/",
  },
  {
    id: 3,
    name: "Github",
    img: o2,
    link: "https://github.com/Abhishekkuntare",
  },
  {
    id: 4,
    name: "Portfolio v1.",
    img: o4,
    link: "https://abhishekkuntare0210.vercel.app/",
  },
  {
    id: 5,
    name: "Portfolio v2. (three js).",
    img: o1,
    link: "https://abhishekkuntare3d.vercel.app/",
  },
  {
    id: 6,
    name: "Portfolio x64",
    img: o5,
    link: "https://abhishekkuntare2002.web.app/start",
  },
];
